

import ReactLauncher from './ReactLauncher';
import { TCCRSSReader } from './RSS/TCCRSSReader';

ReactLauncher([
  { tagName: 'TCCRSSReader', component: TCCRSSReader },
]);